export const green = {
  green1: "#060E07",
  green2: "#0C1D0E",
  green3: "#122B17",
  green4: "#18391D",
  green5: "#1F4724",
  green6: "#9AD5A1",
  green7: "#C5E7C9",
};
